export default __webpack_public_path__ + "static/media/before-you-start.bf883783.svg";